module.exports = __webpack_public_path__ + "img/personalised-graduation-clip-and-download.c45d9d99.jpg";